import React from "react";
import Image from "next/image";

export default function Team_Home_Layout2({ data }: { data: any }) {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl   text-center mb-12">{data.title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.founders.map((founder: any) => (
            <div key={founder.id} className="bg-[#F9F7F3] rounded-lg overflow-hidden shadow-md">
              <div className="aspect-square relative">
                <Image
                  src={founder.picture.data.attributes.url}
                  alt={founder.name}
                  fill
                  className="object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl  ">{founder.name}</h3>
                <p className="text-sm text-[#5A534A] mt-1">{founder.designation}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}